import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl: string;
  schemaData?: object;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords,
  canonicalUrl,
  schemaData
}) => {
  // Keep title under 60 chars for SERP display
  const fullTitle = title.length > 60 ? title : title;
  const isHomepage = canonicalUrl === 'https://freepomodorotimer.com' || canonicalUrl === 'https://freepomodorotimer.com/';
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://freepomodorotimer.com/og-image.jpg" />
      <meta property="og:site_name" content="Free Pomodoro Timer" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://freepomodorotimer.com/og-image.jpg" />
      
      {/* Structured Data */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(Array.isArray(schemaData) ? {
            "@context": "https://schema.org",
            "@graph": schemaData
          } : schemaData)}
        </script>
      )}
      
      {/* Breadcrumb Schema - only for non-homepage */}
      {!isHomepage && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://freepomodorotimer.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": title.split(' | ')[0].split(' - ')[0],
                "item": canonicalUrl
              }
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
